<script>
export default {
    name: 'CalendarMiniDateMonth',
    inject: ['$t'],
    props: {
        month: {
            type: String,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        formattedDate: {
            type: Object,
            required: true
        }
    }
};
</script>

<template>
    <div
        class="flex h-[22px] cursor-pointer items-center justify-center rounded-[50px]"
        :class="[
            index === formattedDate.month
                ? 'bg-blue-dusk shadow-base cursor-auto px-1 font-semibold text-white'
                : ''
        ]"
    >
        <span class="h-[17px] text-sm">{{ $t(month) }}</span>
    </div>
</template>
